// extracted by mini-css-extract-plugin
export default {"view-switch":"ViewSwitch_view-switch__L9WNX","view-switch-btn":"ViewSwitch_view-switch-btn__BMsXu","view-switch-btn-active":"ViewSwitch_view-switch-btn-active__9QWHr"};